import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 24;

function AirportIcon({ className, childrenClassNames, w, h }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        className={childrenClassNames.path}
        d="M11.338 20.353A1.4 1.4 0 0 1 10.18 21H9.003L12 13H6l-1.397 1.719a.69.69 0 0 1-.572.303L3 15l1.031-3.497L3 8l1.019.008a.72.72 0 0 1 .524.215L6 10h6L9.003 2h1.177a1.4 1.4 0 0 1 1.158.647L15.996 10h4.654c.778 0 1.352.716 1.352 1.492 0 .777-.574 1.508-1.352 1.508h-4.654z"
      />
    </svg>
  );
}

AirportIcon.defaultProps = {
  w: 24,
  h: 24,
  className: '',
  childrenClassNames: {},
};

AirportIcon.propTypes = {
  className: PropTypes.string,
  childrenClassNames: PropTypes.shape({
    path: PropTypes.string,
  }),
  w: PropTypes.number,
  h: PropTypes.number,
};

AirportIcon.ICON_SIZE = ICON_SIZE;

export default AirportIcon;
